const sitekey = '6LfuupUeAAAAAA9A6ZiaO0YymauoeM5xhHIvwW4O';

export default sitekey;
